import * as React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { getCurrentRichContent } from "../helpers/richContentHelpers";

const newsPageTplData = (id) => {
    const data = useStaticQuery(
        graphql`
            {
                allWpPage {
                    edges {
                        node {
                            id
                            template {
                                ... on WpTemplate_News {
                                    newsRichContent {
                                        # SECTION: Page Header
                                        pageHeader {
                                            title
                                            text
                                        }
                                        # SECTION: Hero
                                        hero {
                                            category
                                            header
                                            secondHeader
                                            text
                                            buttons {
                                                button {
                                                    variant
                                                    link {
                                                        target
                                                        title
                                                        url
                                                    }
                                                }
                                            }
                                            image {
                                                localFile {
                                                    extension
                                                    childImageSharp {
                                                        gatsbyImageData(
                                                            width: 1800
                                                            placeholder: BLURRED
                                                            quality: 100
                                                        )
                                                    }
                                                }
                                            }
                                            backgroundImage {
                                                localFile {
                                                    extension
                                                    childImageSharp {
                                                        gatsbyImageData(
                                                            width: 1800
                                                            placeholder: BLURRED
                                                            quality: 100
                                                        )
                                                    }
                                                }
                                            }
                                        }

                                        # SECTION: Posts List
                                        postsList {
                                            postsPerPage
                                        }

                                      # SECTION: FAQ
                                      faqSection {
                                        header
                                        items {
                                          question
                                          answer
                                        }
                                    }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        `
    );

    return getCurrentRichContent(data, id, "newsRichContent");
};

export { newsPageTplData };
